import { ReactComponent as ChaletIcon } from 'assets/ic_chalet.svg';
import { Box } from '@mui/material';

type Props = {
  width?: number;
  height?: number;
};

export default function ChaletLogo({ width = 100, height = 100 }: Props) {
  return (
    <Box
      bgcolor="primary.main"
      width={150}
      height={150}
      display="flex"
      alignItems="center"
      justifyContent="center"
      alignSelf="center"
      borderRadius={50}
      sx={{ color: 'white' }}>
      <ChaletIcon style={{ width, height, color: 'white', transform: 'translateX(5px)' }} />
    </Box>
  );
}
